import Vue from 'vue'
import { Icon, Toast } from 'vant'
import 'vant/lib/index.css';

Vue.prototype.$toast = Toast
Vue.use(Icon)
